module.exports = __webpack_public_path__ + "img/la.6b86f25a.svg";